import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProductTypeSpec } from "../../types/prtoduct-type-specs";
import { localizeNumbers } from "../../functions";
import { IconName } from "@fortawesome/free-solid-svg-icons";

export interface ProductPropertyProps {
  key: number;
  spec: ProductTypeSpec;
  productSpecUnit: string | null;
  value: number;
  description: string | null;
  imageUrl: string | null;
}

export default function ProductProperty({
  key,
  value,
  spec,
  description,
  productSpecUnit,
  imageUrl,
}: ProductPropertyProps) {
  var { title, icon, unit, id } = spec;
  icon = icon.replace("fa-", "") as IconName;

  //console.log("imageUrl", imageUrl);
  return (
    <div
      className={
        id === 10
          ? "flex items-center gap-4 p-4 border rounded-xl shadow-sm justify-between"
          : "innerbox col-xs-12 flex items-center"
      }
      title={title}
    >
      {id === 10 && description !== null ? (
        <>
          <div className="flex flex-col">
            <span className="text-gray-600 text-sm mb-2">{description}</span>
          </div>
          {imageUrl && (
            <img
              src={imageUrl!}
              alt={title}
              className="w-20 h-20 rounded-xl object-cover mr-4"
            />
          )}
        </>
      ) : (
        <div>
          <FontAwesomeIcon icon={icon} className="text-grey mr-2" />
          <span className="bigger-150 font-bolder orange pr-2">
            {localizeNumbers(value)}
          </span>
          <span>{" " + (unit || productSpecUnit || "")}</span>
          {description?.length! > 0 ? (
            <span className="smaller-90 grey ml-2">{description}</span>
          ) : (
            id === 10 && "مودم ندارد"
          )}
        </div>
      )}
    </div>
  );
}
